export default __webpack_public_path__ + "static/media/laptop_de.c423b0ef.png";